<template>
  <enfold>
    <div class="terminal-log">
      <enfold-ucd>
        <template slot="up">
          <!-- <el-tooltip class="item" effect="dark" :content="$t('log.export')" placement="top-start">
						<i class="icon"><div class="export" @click="exportExcel"></div></i>
					</el-tooltip> -->
          <div class="c-u-left flex-b-c">
            <div>
              <el-button v-if="APPVERSION !== '124'" size="mini" round type="primary" icon="el-icon-document" @click="exportExcel">{{
                $t('log.export') }}</el-button>
            </div>
            <div class="flex-b-c" style="margin-left: 32px; font-size: 14px">
              <span style="margin-right: 8px;">{{ $t('clo1') }}:</span>
              <el-date-picker v-model="date_pick" type="datetimerange" :picker-options="pickerOptions"
                :range-separator="$t('clo2')" :start-placeholder="$t('clo3')" :end-placeholder="$t('clo4')"
                align="right" size="mini" class="margin-8" @change="changeTime"></el-date-picker>
            </div>
          </div>
          <div class="c-u-right">
            <div class="search_input">
              <el-input v-model="search_data" size="mini" :placeholder="$t('review.enterKey')">
                <i slot="suffix" class="el-icon-search" @click="search"></i>
              </el-input>
            </div>
          </div>
        </template>
        <template slot="center">
          <el-table :data="operateList" style="width: 100%" v-loading="loading" height="100%">
            <el-table-column prop="user_name" :label="$t('log.operateUser')"></el-table-column>
            <el-table-column prop="controller" :label="$t('log.function')">
              <template slot-scope="scope">
                {{ `${scope.row.module}/${scope.row.controller}/${scope.row.action}` }}
              </template>
            </el-table-column>
            <el-table-column prop="title" :label="$t('log.describe')">
              <template slot-scope="scope">
                {{ i18nTitle(scope.row.title, scope.row.action) }}
              </template>
            </el-table-column>
            <el-table-column prop="create_time" :label="$t('log.operateTime')" width="180" sortable></el-table-column>
          </el-table>
        </template>
        <template slot="down">
          <pagination :current="current" :limit="limit" @currentChange="currentChange">
          </pagination>
        </template>
      </enfold-ucd>
    </div>
    <export-dialog :exportDialogVisible="exportDialogVisible" :logList="operateList" @changeShow="showAdd"
      type="operate">
    </export-dialog>
    <msg-dialog :dialogVisible="msgDialogVisible" @closeDialog="closeDialog" top="20vh" title="设备筛选"></msg-dialog>
  </enfold>
</template>

<script>
// const year = new Date().getFullYear();
// const month = new Date().getMonth();
// const date = new Date().getDate();
import EnfoldUcd from "@/components/basics/EnfoldUCD"
import Enfold from "@/components/basics/Enfold"
import pagination from '@/components/basics/Pagination'
import ExportDialog from './children/ExportDialog.vue'
import MsgDialog from '@/components/basics/MsgDialog'
import { mPagination } from "@/components/basics/mixins";

const i18nList = [
  { adminLog01: "审核设置成功" },
  { adminLog02: "审核权限清空成功" },
  { adminLog03: "添加设备成功" },
  { adminLog04: "添加素材成功" },
  { adminLog05: "上传素材文件成功" },
  { adminLog06: "删除设备成功" },
  { adminLog07: "添加节目成功" },
  { adminLog08: "添加发布成功" },
  { adminLog09: "添加用户成功" },
  { adminLog10: "编辑用户成功" },
  { adminLog11: "删除素材成功" },
  { adminLog12: "编辑设备成功" },
  { adminLog13: "删除节目成功" },
  { adminLog14: "编辑节目成功" },
  { adminLog15: "修改自身信息成功" },
  { adminLog16: "审核设置成功" },
  { adminLog17: "添加目录成功" },
  { adminLog18: "删除用户成功" },
  { adminLog19: "编辑目录成功" },
  { adminLog20: "移动目录成功" },
  { adminLog21: "删除目录成功" },
  { adminLog22: "删除发布成功" },
  { adminLog23: "添加素材成功" },
  { adminLog24: "重新发布成功" },
  { adminLog25: "发布审核执行成功" },
  { adminLog26: "节目审核执行成功" },
  { adminLog27: "素材审核执行成功" },
  { adminLog28: "登录地址" },
  { adminLog29: "关屏" },
  { adminLog30: "开屏" },
  { adminLog31: "信号切换" },
  { adminLog32: "定时指令" },
  { adminLog33: "重启" },
  { adminLog34: "亮度调节" },
  { adminLog35: "定时播放开关" },
  { adminLog36: "音量调节" },
  { adminLog37: "继电器开关" },
  { adminLog38: "时区校准" },
  { adminLog39: "定时开机" },
  { adminLog40: "系统升级" },
  { adminLog41: "多屏同步" },
  { adminLog42: "云看护开关" },
  { adminLog43: "Apk升级" },
  { adminLog44: "截屏" },
  { adminLog45: "终端指令" }
];

export default {
  name: 'TerminalLog',
  mixins: [mPagination],
  components: {
    Enfold,
    EnfoldUcd,
    ExportDialog,
    pagination,
    MsgDialog,
    //FormDialog
  },
  data() {
    return {
      APPINDIA: process.env.VUE_APP_INDIA,
      APPVERSION: process.env.VUE_APP_VERSION,
      check: true,
      exportDialogVisible: false,
      msgDialogVisible: false,
      operateList: [],
      loading: false,
      search_data: '',
      // startDate: new Date(year, month, date),
      // endDate: new Date(year, month, date),
      date_pick: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 30), new Date()],
      pickerOptions: {
        shortcuts: [{
          text: this.$t('clo5'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('clo6'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('clo7'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  methods: {
    showAdd(data) {
      if (data === 'false') {
        this.exportDialogVisible = false
      } else {
        this.exportDialogVisible = true
      }
    },
    openFilterDialog() {
      this.msgDialogVisible = true;
    },
    closeDialog(isConfirm) {
      if (isConfirm) {
        //console.log("确定...")
      }
      this.msgDialogVisible = false;
    },
    getOperateList(params) {
      this.loading = true;
      let log = {
        limit: this.limit,
        page: this.page,
        key_word: this.keyword,
        group_ids: this.groupIds,
        startTime: this.date_pick[0].toLocaleString(),
        endTime: this.date_pick[1].toLocaleString(),
        ...params
      };
      this.$http.post("/admin/log/userOperationList", log, data => {
        //console.log(data)
        this.operateList = data.data ? data.data : [];
        this.current = parseInt(data.total);
        this.loading = false;
      });
    },
    changeTime(time) {
      if (!time) {
        this.date_pick = ['', ''];
      }
      // const [start, end] = time;
      // console.log(start.toLocaleString(), end.toLocaleString());
      // 
      this.getOperateList();
    },
    search() {
      this.getOperateList({ key_word: this.search_data });
    },
    currentChange(val) {
      this.page = val;
      this.getOperateList();
    },
    exportExcel() {
      this.exportDialogVisible = true;
    },
    closeExportDialog(isConfirm) {
      if (isConfirm) {
        //console.log("导出.....")
      }
      this.exportDialogVisible = false;
    },
    i18nTitle(title, action) {

      if (action === 'generalCommand') {
        const text = "终端指令<541,540,498->信号切换>";
        const regex = /^([\u4e00-\u9fa5]+).*?->([\u4e00-\u9fa5]+)/;
        const match = text.match(regex);

        if (match) {
          const extractedText = match[2];
          const i18nValue = i18nList.find((l) => {
            const val = Object.values(l)[0];
            return val === extractedText;
          });

          let value = "";
          if (i18nValue) {
            value = Object.keys(i18nValue)[0];
          } else {
            return title;
          }


          const newText = title.replace(
            /([\u4e00-\u9fa5]+)(<.*?->)([\u4e00-\u9fa5]+)/,
            `${this.$t('adminLog45')}$2${this.$t(value)}`
          );
          return newText;
        }
        return title;
      }
      const regex = /^([\u4e00-\u9fa5]+)<[^>]*>/;
      const match = title.match(regex);

      if (match) {

        const extractedText = match[1];
        const i18nValue = i18nList.find((l) => {
          const val = Object.values(l)[0];
          return val === extractedText;
        });

        let value = "";
        if (i18nValue) {
          value = Object.keys(i18nValue)[0];
        } else {
          return title;
        }

        const regex = /^([\u4e00-\u9fa5]+)(<[^>]*>)/;
        const replacedText = title.replace(regex, `${this.$t(value)}$2`);

        return replacedText;
      }
    }
  },
  created() {
    this.getOperateList();
  }
}
</script>

<style lang="scss" scoped>
.terminal-log {
  height: 100%;

  .choose_button {
    margin-left: 50%;
  }

  .c-u-left {
    /deep/ .el-input__inner {
      border-radius: 15px;
    }
  }

  .topcon {
    display: flex;
    justify-content: space-between;
    padding: 1%;
    width: 100%;
    align-items: center;

    .search {
      flex-basis: 26%;
      display: flex;
      height: 100%;
      background-color: #edfbff;
      border-radius: 30px;
      margin-right: -60%;

      .search_input {
        flex-basis: 80%;
      }

      .search_button {
        flex-basis: 20%;
        height: 40px;
        background-image: url(~@/assets/images/public/public_search.png);
        background-size: 60%;
        background-repeat: no-repeat;
        background-position: center;
      }
    }

    .c-u-right {
      flex-basis: 270px;
      display: flex;
      height: 100%;
      background-color: #edfbff;
      border-radius: 30px;
    }

    .filter {
      width: 30px;
      height: 30px;
      background-image: url(~@/assets/images/public/public_filter.png);
      background-position: center;
      background-size: 100%;
    }

    .filter:hover {
      cursor: pointer;
    }

    .search_button:hover {
      cursor: pointer;
    }
  }

  /deep/ .cell {
    font-size: 16px;
  }

  /deep/ .el-table__header-wrapper {
    .cell {
      font-size: 18px;
      color: var(--theme-color-customized-1);
    }

    .el-table__header tr,
    .el-table__header th {
      padding: 6.5px 0 !important;
    }
  }
}

// .right {
// 	display: flex;
// 	width: 35%;
// 	justify-content: space-between;
// }
.export {
  width: 40px;
  height: 40px;
  background-image: url(~@/assets/images/public/public_upload.png);
  background-size: 100%;
  background-position: center;
}

.picker {
  height: 20vh;
  position: relative;

  .content {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
  }
}

.pick span {
  padding: 5px;
}

.export:hover {
  cursor: pointer;
}

.c-u-right {
  /deep/ .el-input__inner {
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
  }

  /deep/ .el-input__suffix {
    line-height: 30px;
    color: var(--theme-color-customized-1);
    font-size: 16px;
    right: 10px;
  }
}

.search /deep/ .el-button--default {
  background-color: #edfbff;
  border-left-style: none;
  border-left: 0;
}

.datepick /deep/ .el-input__inner {
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  background-color: #edfbff;
  border: 0;
}

// .pick /deep/ .el-date-editor{
// 	background-color: #edfbff;
// 	border-style: none;
// 	border-radius: 30px;
// }
// .pick /deep/ .el-range-input{
// 	background-color: #edfbff;
// }

.pick /deep/ .el-date-editor {
  border-style: none;
  border-radius: 30px;
  background-color: #edfbff;
  // background-color: pink;
  //padding: 0;
}

// .pick /deep/ .el-range-input {
// 	height: 100%;

// 	width: 45%;

// }

// .pick /deep/ .el-range-input:hover {
// 	cursor: pointer;
// }

// .pick /deep/ .el-range-separator {
// 	width: 30px;
// 	color: #c4e3f6;
// }

.pick /deep/ .el-input__icon {
  display: none;
}
</style>
